import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Check, X, ChevronLeft, ChevronRight } from 'lucide-react';

const Toggle = forwardRef(({ id = "toggle_" + uuidv4(), onToggleChange, classes, isDouble = false }, ref) => {
    const [isChecked, setIsChecked] = useState(false);

    // Funzione per gestire il cambiamento del toggle
    const handleToggleChange = () => {
        const newCheckedState = !isChecked;
        // console.log("Cambiato ", newCheckedState);
        setIsChecked(newCheckedState);
        if (onToggleChange) {
            onToggleChange(newCheckedState);
        }
    };

    // Esponiamo una funzione getter tramite ref
    useImperativeHandle(ref, () => ({
        getValue: () => isChecked,
        setValue: (value) => setIsChecked(value),
    }));

    return (
        <label
            htmlFor={id}
            className={`flex items-center cursor-pointer select-none text-black dark:text-white ${classes}`}
        >
            <div className="relative">
                <input
                    type="checkbox"
                    id={id}
                    className="peer sr-only"
                    checked={isChecked}
                    onChange={handleToggleChange}
                />
                <div className={`block h-8 rounded-full ${isChecked || isDouble ? 'bg-blue-600' :'bg-gray-200 dark:bg-neutral-800'} w-14`}></div>
                <div className={`absolute flex items-center justify-center w-6 h-6 transition bg-white rounded-full dot dark:bg-dark-5 left-1 top-1 ${isChecked ? 'translate-x-full bg-primary' : ''}`} >
                    <span className={isChecked ? 'hidden' : isDouble ? 'text-blue-600  inactive' : 'text-gray-400 dark:text-neutral-600  inactive'}>
                        {
                            isDouble ?
                                <ChevronLeft size={16} strokeWidth={3} className="" />
                                :
                                <X size={16} strokeWidth={3} className="" />
                        }
                    </span>
                    <span className={isChecked ? 'text-blue-600 active' : 'hidden'}>
                        {
                            isDouble ?
                                <ChevronRight size={16} strokeWidth={3} className="" />
                                :
                                <Check size={16} strokeWidth={3} className="" />
                        }
                    </span>
                </div>
            </div>
        </label>
    );
});

export default Toggle;